var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_294_1797)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.50001 8.25001H9.75002C10.5784 8.25001 11.25 7.57842 11.25 6.75V1.50001C11.25 0.67159 10.5784 0 9.74999 0H1.50001C0.67159 0 0 0.67159 0 1.50001V6.75C0 7.57842 0.67159 8.25001 1.50001 8.25001Z",
    fill: "#001C00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7435 0.6615C17.4647 0.247992 16.9986 7.03125e-05 16.5 0H14.25C13.4215 0 12.75 0.67159 12.75 1.50001V6.75C12.75 7.57842 13.4215 8.25001 14.25 8.25001H16.5C17.3284 8.25001 18 7.57842 18 6.75V1.50001C18.0004 1.20111 17.9111 0.908965 17.7435 0.6615Z",
    fill: "#001C00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.58849 10.0064C4.34102 9.83882 4.04888 9.74945 3.74998 9.74994H1.49998C0.67159 9.74994 0 10.4215 0 11.25V16.4999C0 17.3284 0.67159 18 1.50001 18H3.75001C4.57843 18 5.25002 17.3284 5.25002 16.4999V11.25C5.24992 10.7513 5.002 10.2852 4.58849 10.0064Z",
    fill: "#001C00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3385 10.0064C17.091 9.83882 16.7989 9.74945 16.5 9.74994H8.25001C7.42159 9.74994 6.75 10.4215 6.75 11.25V16.4999C6.75 17.3284 7.42159 18 8.25001 18H16.5C17.3284 18 18 17.3284 18 16.4999V11.25C17.9999 10.7513 17.752 10.2852 17.3385 10.0064Z",
    fill: "#001C00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_294_1797"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.bd2ed76f.svg";
export { ForwardRef as ReactComponent };